import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  Injector,
  Input,
  OnInit,
} from '@angular/core';
import { Store } from '@sama/app-state';
import { get, matches } from '@sama/micro-dash';
import { DirectiveSuperclass } from '@sama/ng-core';
import { combineLatest, Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import {
  isKeypointShapeStore,
  KeypointShapeState,
  ShapeState,
} from '../../../../../../cross-team-shared/annotation/shared/state/shape-state';
import { TagService } from '../../../../../../outputs/annotation/annotation-shared/utils/tag.service';
import { KeypointOptionClass } from '../../../../../../team-apis/otterdam/keypoint-options';
import { AnnotationOutput } from '../../../../../../team-apis/otterdam/outputs/annotation-output';
import {
  OutputInfo,
  outputInfoStoreToken,
} from '../../../../../h3ml/state/output-info';

@Component({
  selector: 'h3-objectless-shape-label',
  templateUrl: './objectless-shape-label.component.html',
  styleUrls: ['./objectless-shape-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
/** @deprecated used for old projects without objects */
export class ObjectlessShapeLabelComponent
  extends DirectiveSuperclass
  implements OnInit
{
  @Input() shapeStore?: Store<ShapeState>;
  firstAvailableLabel$!: Observable<string>;

  constructor(
    @Inject(outputInfoStoreToken)
    private outputInfoStore: Store<OutputInfo<AnnotationOutput>>,
    private tagService: TagService,
    injector: Injector,
  ) {
    super(injector);
  }

  ngOnInit() {
    this.firstAvailableLabel$ = this.getInput$('shapeStore').pipe(
      switchMap((shapeStore) => {
        if (!shapeStore) {
          return of('Scene');
        }
        const labelObservables = this.tagService
          .getSummaryOutputsForDisplay()
          .map((output) => this.tagService.getLabel$(output, shapeStore));
        if (isKeypointShapeStore(shapeStore)) {
          labelObservables.unshift(this.buildKeypointClassLabel$(shapeStore));
        }
        labelObservables.push(of('')); // To clean up 'Scene' if no labels
        return combineLatest(labelObservables).pipe(
          // fix me if you change this code
          // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- fix me!
          map((labels) => labels.filter((label: string) => !!label)?.[0]),
        );
      }),
    );
  }

  private buildKeypointClassLabel$(shapeStore: Store<KeypointShapeState>) {
    const classes = getKeypointOptionClasses(
      this.outputInfoStore.state().output,
    );
    return shapeStore('keypointClass').$.pipe(
      map((keypointClass) => {
        const keypointOptionClass = classes.find(
          matches({ name: keypointClass }),
        );
        if (keypointOptionClass) {
          return keypointOptionClass.label;
        } else {
          return `invalid class: ${keypointClass}`;
        }
      }),
    );
  }
}

function getKeypointOptionClasses(
  output: AnnotationOutput,
): KeypointOptionClass[] {
  return get(output.meta, ['keypoint_options', 'classes'], []);
}
